import { render, staticRenderFns } from "./rmHsab2.vue?vue&type=template&id=58f47de0"
import script from "./rmHsab2.vue?vue&type=script&lang=js"
export * from "./rmHsab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports